// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3OM2l","content":"ManualTimeModal_content__3HPZM"};